/**
 * safeStorage - دسترسی ایمن به localStorage
 * در حالت Private Browsing برخی مرورگرها localStorage خطا می‌دهد
 */

/**
 * خواندن مقدار از localStorage با try-catch
 * @param {string} key - کلید مورد نظر
 * @param {string|null} fallback - مقدار پیش‌فرض در صورت خطا (پیش‌فرض: null)
 * @returns {string|null}
 */
export const safeGetItem = (key, fallback = null) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    console.warn(`localStorage.getItem("${key}") failed:`, e.message);
    return fallback;
  }
};

/**
 * ذخیره مقدار در localStorage با try-catch
 * @param {string} key - کلید مورد نظر
 * @param {string} value - مقدار مورد نظر
 * @returns {boolean} آیا ذخیره موفق بود
 */
export const safeSetItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn(`localStorage.setItem("${key}") failed:`, e.message);
    return false;
  }
};

/**
 * حذف مقدار از localStorage با try-catch
 * @param {string} key - کلید مورد نظر
 */
export const safeRemoveItem = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.warn(`localStorage.removeItem("${key}") failed:`, e.message);
  }
};
